<template>
	<v-autocomplete prepend-inner-icon="mdi-map-marker" v-model="selectedPlace" clearable
		@update:modelValue="onPlaceSelected" :items="autocompleteItems" :loading="isLoading"
		v-model:search="searchInput" :label="label" :placeholder="placeholder" item-title="place" return-object
		item-value="place_id" no-data-text="Type and search location" variant="outlined" density="compact"
		hint="Type and search location" cache-items class="w-full mt-2" persistent-hint
		persistent-placeholder></v-autocomplete>
</template>

<script setup>
import debounce from 'lodash.debounce';


const searchInput = ref('');
const isLoading = ref(false);
const debouncedSearch = debounce(searchPlaces, 300);
const store = useBookingStore();
const model = defineModel();
const autocompleteItems = ref([]);
const selectedPlace = ref(null);
const props = defineProps({
	placeholder: String,
	label: String,
	bias: String,
});
let searchCache = toRef(() => store.getPlaceSearchCache);
async function searchPlaces() {
	if (!searchInput.value || searchInput.value.length < 3) {
		autocompleteItems.value = searchCache.value;
		return;
	}

	if (model.value && selectedPlace.value && model.value.place_id === selectedPlace.value.place_id) {
		return;
	}


	await serverSideFetch();
}
const serverSideFetch = async () => {
	autocompleteItems.value = [];
	selectedPlace.value = null;
	isLoading.value = true;
	try {
		const payload = { searchText: searchInput.value };
		if (props.bias) {
			payload.bias = props.bias;
		}
		const response = await fetch('/api/places/get-places', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});
		autocompleteItems.value = [{ place: 'Not Listed - To be Provided', place_id: 'TBPLater' }, ...(await response.json())];

		store.setPlaceSearchCache(autocompleteItems.value);
	} catch (error) {
		console.error('Error fetching autocomplete data:', error);
	} finally {
		isLoading.value = false;
	}
};

const onPlaceSelected = () => {
	model.value = selectedPlace.value;
};


onMounted(() => {


	setTimeout(() => {
		if (model.value) {
			autocompleteItems.value = model.value ? [model.value] : [];
			selectedPlace.value = model.value ? model.value : null;
		}

	}, 500);
	// nextTick(() => {
	// 	console.log('NextTickFunc', model.value);
	// });
	// // if (model.value) {
	// // 	autocompleteItems.value = model.value ? [model.value] : [];
	// // 	selectedPlace.value = model.value ? model.value : null;
	// // }

});
watch(
	searchInput,
	() => {
		if (searchInput.value.length <= 3) return;
		debouncedSearch();
	},
	{ deep: true }
);
</script>
